function initLoginSignup() {
  const root = document.querySelector("[data-login-signup]");
  if (!root) return;
  const tabs = root.querySelectorAll(".login-signup__tab");
  const loginPanel = root.querySelector('[id^="login-"]');
  const signupPanel = root.querySelector('[id^="signup-"]');
  if (!loginPanel || !signupPanel) return;

  function activate(name) {
    const isLogin = name === "login";
    tabs.forEach((t) =>
      t.classList.toggle("is-active", t.dataset.tab === name)
    );
    loginPanel.classList.toggle("is-active", isLogin);
    signupPanel.classList.toggle("is-active", !isLogin);
    loginPanel.hidden = !isLogin;
    signupPanel.hidden = isLogin;
    try {
      if (history && history.replaceState) {
        history.replaceState(
          null,
          "",
          `${location.pathname}${location.search}#${name}`
        );
      }
    } catch (_) {}
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      activate(tab.dataset.tab);
    });
  });

  // Hook up DOB -> customer[note]
  const dobInput = root.querySelector('[id^="RegisterDOB-"]');
  const noteInput = root.querySelector('[id^="RegisterNote-"]');
  const signupForm = signupPanel.querySelector("form");
  if (dobInput && noteInput && signupForm) {
    signupForm.addEventListener("submit", () => {
      noteInput.value = dobInput.value ? `DOB: ${dobInput.value}` : "";
    });
  }

  // Recover form toggling within login panel
  const loginFormWrap = root.querySelector("[data-login-form]");
  const recoverFormWrap = root.querySelector("[data-recover-form]");
  function showRecover(show) {
    if (!loginFormWrap || !recoverFormWrap) return;
    loginFormWrap.hidden = !!show;
    recoverFormWrap.hidden = !show;
    // Lets the CSS hide the Login/Sign Up tabs while resetting — leaving
    // "Login" lit above a reset form is what made the screen unreadable.
    root.classList.toggle("is-recovering", !!show);
  }

  root.addEventListener("click", (e) => {
    const target = e.target.closest("a");
    if (!target) return;
    if (target.matches('[href$="#recover"]')) {
      e.preventDefault();
      activate("login");
      showRecover(true);
      try {
        history.replaceState(
          null,
          "",
          `${location.pathname}${location.search}#recover`
        );
      } catch (_) {}
    }
    if (target.hasAttribute("data-recover-cancel")) {
      e.preventDefault();
      activate("login");
      showRecover(false);
      try {
        history.replaceState(
          null,
          "",
          `${location.pathname}${location.search}#login`
        );
      } catch (_) {}
    }
  });

  const hash = (location.hash || "").replace("#", "");
  const path = location.pathname || "";
  const defaultTab = path.includes("/account/register") ? "signup" : "login";
  if (hash === "recover") {
    activate("login");
    showRecover(true);
  } else {
    activate(hash === "signup" ? "signup" : defaultTab);
    showRecover(false);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLoginSignup);
} else {
  initLoginSignup();
}
